import { flow, get, find, isEqual, every, getOr, size, values } from 'lodash/fp';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InstallationSummary from './InstallationSummary';
import cartEstimate from '../../../actions/cartEstimate';
import updateInstallationPricing from '../../../actions/getInstallationPricing';
import calculateTax from '../../../actions/calculateTax';
import { getInvalidItemsCount } from '../../../selectors/getInvalidItemsCount';
import locale from './InstallationSummary.locale';

import getInstallationPricing from '../../../helpers/installationPricing';

import designPricing from '../../../services/designPricing/design';
import getItemsWithPurchaseOptionIn from '../../../helpers/mandi/getItemsWithPurchaseOptionIn';
import getItemsWithProducts from '../../../helpers/mandi/getItemsWithProducts';

const excludeCharges = [
  'windowRemoval',
  'windowHaul',
  'windowAdjustment',
  'windowadjustment',
];

const mapStateToProps = ({ estimateBuilder: { entities, uiState, mandi } }, { designId }) => {
  const { items, containers } = entities;

  const estimate = getOr({}, `estimates.byId[${designId}]`)(entities);
  const {
    isLockedOrOrdered,
    attributes,
    attributes: {
      isAutoReleaseDesign,
    },
  } = estimate;


  const { charges } = getOr({}, `designs.${designId}.pricingResult`)(mandi);
  const { totalInstallationCost } = getInstallationPricing(charges, {}, excludeCharges);
  const customer = JSON.parse(attributes.customer);
  const propertyAddress = JSON.parse(attributes.propertyAddress);
  const selectedInstallWindows = getItemsWithPurchaseOptionIn(['product-and-install'], designId)(items.byId);
  const itemsWithProducts = getItemsWithProducts(designId)(items.byId);

  const getPromoEndDate = (promoEndDateFromApi) => {
    // promoEndDateFromApi is in UTC. The following will convert it to local time
    // and will subtract a day if the local time is between 12:00 AM - 5:30 AM.
    // This is a short term solution and may change in the future.
    const endDate = new Date(promoEndDateFromApi);
    const hour = endDate.getHours();
    const minute = endDate.getMinutes();

    if ((hour === 5 && minute <= 30) || (hour >= 0 && hour < 5)) {
      endDate.setDate(endDate.getDate() - 1);
    }

    return endDate.toLocaleDateString('en-US');
  };

  const invalidItemCount = getInvalidItemsCount(entities, designId);

  const retail = designPricing(containers.byId, items.byId, 'retail', estimate);
  const subtotal = designPricing(containers.byId, items.byId, 'subtotal', estimate);
  const selectedWindows = getItemsWithPurchaseOptionIn(['product-and-install', 'product-only'], designId)(items.byId);
  const isProductOnly = every(flow(
    get('attributes'),
    find({ name: 'purchaseOption' }),
    get('value'),
    isEqual('product-only'),
  ))(selectedWindows);

  const tax = getOr(0, `designs.${designId}.tax`)(mandi);

  const calculateTaxModel = {
    customerEmail: customer.email,
    orderNumber: attributes.orderNumber,
    siteId: 3,
    shippingAddress: {
      firstName: customer.firstName,
      lastName: customer.lastName,
      address1: propertyAddress.line1,
      address2: propertyAddress.line2,
      city: propertyAddress.city,
      province: propertyAddress.state,
      postalCode: propertyAddress.zipcode,
      phone: customer.phones[0].number,
      country: 'us',
    },
    lineItems: values(items.byId).filter(item => item.itemProduct !== null).map((item, index) => ({
      number: index + 1,
      amount: item.retail,
      quantity: item.quantity,
      productId: item.itemProduct.skuNumber,
      productName: item.itemProduct.productName,
      discounted: item.discountAmount > 0,
      taxCode: null,
      origin: null,
      destination: null,
      lineItemGroupGuid: item.itemProduct.configurationGuid,
    })),
  };

  return {
    excludeCharges,
    name: estimate.name,
    subtotal,
    retail,
    tax,
    calculateTaxModel,
    totalInstallationCost,
    promo: {
      code: estimate.promoCode,
      endDate: estimate.promoEndDate ? getPromoEndDate(estimate.promoEndDate) : null,
    },
    containerIds: estimate.containers,
    disableDiyCheckout: invalidItemCount > 0 || size(selectedWindows) === 0 || isLockedOrOrdered,
    disableDiyAddToOrder: isAutoReleaseDesign === 'true' && (invalidItemCount > 0 || size(selectedWindows) === 0 || isLockedOrOrdered || size(itemsWithProducts) === 0),
    selectedWindows,
    isProductOnly,
    isLinked: entities.estimates.byId[uiState.selectedEstimate].isLinked,
    locale,
    selectedInstallWindows,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  cartEstimate,
  updateInstallationPricing,
  calculateTax,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InstallationSummary);
